import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageContainer } from '../../../shared/components/PageContainer';
import { PurchaseRequestForm, type PurchaseRequestSubmission } from '../components/PurchaseRequestForm';
import { purchaseErrorMessage } from '../api';
import { useCreatePurchaseRequest, usePurchaseCatalogs, useUploadPurchaseAttachment } from '../hooks';

export default function NovaSolicitacaoPage() {
  const navigate = useNavigate();
  const catalogs = usePurchaseCatalogs(false);
  const create = useCreatePurchaseRequest();
  const upload = useUploadPurchaseAttachment();
  const [error, setError] = useState<string | null>(null);

  async function submit(submission: PurchaseRequestSubmission) {
    setError(null);
    try {
      const created = await create.mutateAsync(submission.payload);
      if (submission.attachment) await upload.mutateAsync({ requestId: created.id, ...submission.attachment });
      navigate(`/compras/solicitacoes/${created.id}`);
    } catch (caught) {
      setError(purchaseErrorMessage(caught));
    }
  }

  return (
    <PageContainer
      title="Nova solicitação de compra"
      subtitle="Salve o rascunho com vínculos, escopo, acessos, itens e evidências"
      breadcrumbs={[{ label: 'Compras', to: '/compras' }, { label: 'Nova solicitação' }]}
    >
      <PurchaseRequestForm
        costCenters={catalogs.costCenters.data ?? []}
        clients={catalogs.clients.data ?? []}
        projects={catalogs.projects.data ?? []}
        loadingCatalogs={catalogs.costCenters.isLoading || catalogs.clients.isLoading || catalogs.projects.isLoading}
        submitting={create.isPending || upload.isPending}
        submitError={error}
        onSubmit={(value) => void submit(value)}
        onCancel={() => navigate('/compras')}
      />
    </PageContainer>
  );
}
